module.exports = __webpack_public_path__ + "static/img/logo.d947b23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/logo.png
// module id = 282
// module chunks = 30